module.exports = __webpack_public_path__ + "static/media/predictorImg.c8dd0bb0.png";